import React, { useState, useMemo } from 'react'
import styled from 'styled-components'
import Header from 'components/VerticalLayout/Header'
import bgImage from '../../../../assets/images/bgImage1.jpg'
import faqData from '../QnAData/faqData'

// ---------- styled components ----------

const HeroSection = styled.div`
  background: linear-gradient(135deg, #0f172a 0%, #14213d 55%, #0d47a1 100%);
  padding: 80px 24px 32px;
  text-align: center;
`

const HeroTitle = styled.h1`
  font-size: 1.8rem;
  font-weight: 900;
  color: #fff;
  letter-spacing: -0.03em;
  margin-bottom: 8px;

  span {
    background: linear-gradient(135deg, #4fc3f7, #1e88e5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`

const HeroSubtitle = styled.p`
  color: #94a3b8;
  font-size: 1rem;
  max-width: 600px;
  margin: 0 auto 18px;
`

const SearchWrap = styled.div`
  max-width: 480px;
  margin: 0 auto;
  position: relative;
`

const SearchInput = styled.input`
  width: 100%;
  padding: 9px 16px 9px 40px;
  border-radius: 12px;
  border: 2px solid rgba(255, 255, 255, 0.12);
  background: rgb(255, 255, 255);
  color: #030303;
  font-size: 0.9rem;
  font-family: inherit;
  outline: none;

  &::placeholder {
    color: #64748b;
  }
  &:focus {
    border-color: #0d47a1;
    background: rgba(255, 255, 255, 0.94);
  }
`

const SearchIcon = styled.span`
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1rem;
`

const SearchCount = styled.div`
  margin-top: 10px;
  font-size: 0.8rem;
  color: #94a3b8;
  min-height: 18px;
`

const NeedHelp = styled.div`
  margin-top: 14px;
  font-size: 0.85rem;
  color: #94a3b8;

  a {
    color: #4fc3f7;
    text-decoration: none;
    font-weight: 600;
  }
`

const ContentWrap = styled.div`
  background: #f8fafc;
  min-height: 60vh;
`

const Layout = styled.div`
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 24px 64px;
  gap: 28px;
  align-items: flex-start;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`

const Sidebar = styled.aside`
  width: 220px;
  flex-shrink: 0;
  position: sticky;
  top: 90px;

  @media (max-width: 960px) {
    width: 100%;
    position: static;
  }
`

const SidebarTitle = styled.h3`
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #64748b;
  margin-bottom: 8px;
  padding-left: 4px;
`

const SidebarNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 1px;
`

const SidebarLink = styled.a`
  font-size: 0.8rem;
  color: #64748b;
  text-decoration: none;
  padding: 6px 10px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 7px;

  &:hover {
    background: #e3f2fd;
    color: #1e88e5;
  }
`

const Dot = styled.span`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
`

const Main = styled.main`
  flex: 1;
  min-width: 0;
`

const Section = styled.div`
  margin-bottom: 28px;
`

const SecHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #33C2F4 100%, #0f172a 0%);
  
  border-radius: 14px 14px 0 0;
  cursor: pointer;
  user-select: none;

  &:hover {
    background: linear-gradient(135deg, #33C2F4 100%, #0f172a 0%);
  }
`
// background: linear-gradient(135deg, #0f172a 0%, #33C2F4 100%);
const SecIcon = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.38);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  flex-shrink: 0;
`

const SecTitle = styled.div`
  flex: 1;
  font-size: 0.95rem;
  font-weight: 700;
  color: #fff;
`

const SecCount = styled.div`
  font-size: 0.72rem;
  background: rgba(255, 255, 255, 0.39);
  color: #151414;
  padding: 2px 9px;
  border-radius: 100px;
  font-weight: 600;
`

const SecChev = styled.div`
  color: #94a3b8;
  font-size: 0.85rem;
  transition: transform 0.3s;
  transform: ${({ $collapsed }) => ($collapsed ? 'rotate(-90deg)' : 'rotate(0deg)')};
`

const SecBody = styled.div`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 14px 14px;
  overflow: hidden;
  display: ${({ $collapsed }) => ($collapsed ? 'none' : 'block')};
`

const FaqItemWrap = styled.div`
  border-bottom: 1px solid #e2e8f0;
  display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};

  &:last-child {
    border-bottom: none;
  }
`

const FaqQ = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 15px 20px;
  cursor: pointer;

  &:hover {
    background: #f8fafc;
  }
`

const Qid = styled.span`
  font-size: 0.68rem;
  font-weight: 700;
  color: #1e88e5;
  background: #e3f2fd;
  padding: 2px 7px;
  border-radius: 5px;
  flex-shrink: 0;
  margin-top: 2px;
  font-family: monospace;
`

const QText = styled.span`
  flex: 1;
  font-size: 0.9rem;
  font-weight: 600;
  color: #0f172a;
`

const QChev = styled.span`
  color: #64748b;
  font-size: 0.8rem;
  transition: transform 0.25s;
  flex-shrink: 0;
  margin-top: 3px;
  transform: ${({ $open }) => ($open ? 'rotate(180deg)' : 'rotate(0deg)')};
`

const FaqA = styled.div`
  display: ${({ $open }) => ($open ? 'block' : 'none')};
  padding: 0 20px 16px 50px;
  font-size: 0.875rem;
  color: #334155;
  line-height: 1.75;

  ul,
  ol {
    margin: 8px 0;
    padding-left: 20px;
  }
  li {
    margin-bottom: 4px;
  }
  .chip {
    display: inline-block;
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    padding: 1px 7px;
    border-radius: 5px;
    font-family: monospace;
    font-size: 0.8rem;
    color: #1e88e5;
  }
  .tag {
    display: inline-block;
    background: #e3f2fd;
    color: #1e88e5;
    padding: 1px 8px;
    border-radius: 100px;
    font-size: 0.76rem;
    font-weight: 600;
  }
  a {
    color: #1e88e5;
    font-weight: 600;
  }
  .note {
    margin-top: 10px;
    padding: 9px 13px;
    background: #fffbeb;
    border-left: 3px solid #f59e0b;
    border-radius: 0 8px 8px 0;
    font-size: 0.83rem;
    color: #92400e;
  }
`

const NoResults = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #64748b;

  h3 {
    font-size: 1.05rem;
    font-weight: 700;
    color: #334155;
    margin-bottom: 6px;
  }
`

const Footer = styled.footer`
  background: #0f172a;
  text-align: center;
  padding: 26px 24px;
  color: #475569;
  font-size: 0.8rem;

  a {
    color: #4fc3f7;
    text-decoration: none;
    font-weight: 600;
  }
  strong {
    color: #94a3b8;
  }
`

// ---------- component ----------

const FaqPage = () => {
  document.title = 'Title Appraiser | Products'

  const [query, setQuery] = useState('')
  const [collapsedSections, setCollapsedSections] = useState(new Set())
  const [openItems, setOpenItems] = useState(new Set())

  const toggleSection = (id) => {
    setCollapsedSections((prev) => {
      const next = new Set(prev)
      next.has(id) ? next.delete(id) : next.add(id)
      return next
    })
  }

  const toggleItem = (id) => {
    setOpenItems((prev) => {
      const next = new Set(prev)
      next.has(id) ? next.delete(id) : next.add(id)
      return next
    })
  }

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  const q = query.trim().toLowerCase()

  // when searching, compute which items match and auto-open them
  const { visibleData, totalMatches } = useMemo(() => {
    if (!q) return { visibleData: faqData, totalMatches: 0 }

    let total = 0
    const data = faqData
      .map((section) => {
        const items = section.items.filter((item) =>
          `${item.q} ${item.a}`.toLowerCase().includes(q)
        )
        total += items.length
        return { ...section, items }
      })
      .filter((section) => section.items.length > 0)

    return { visibleData: data, totalMatches: total }
  }, [q])

  return (
    <div className="account">
      <Header />

      <HeroSection
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(15,23,42,0.9), rgba(13,71,161,0.75)), url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <HeroTitle>
          Support &amp; <span>FAQs</span>
        </HeroTitle>
        <HeroSubtitle>
          Got Questions? Find Answers and Support Here.
        </HeroSubtitle>
        <SearchWrap>
          <SearchIcon>🔍</SearchIcon>
          <SearchInput
            type="text"
            placeholder="Search questions…"
            autoComplete="off"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </SearchWrap>
        <SearchCount>
          {q && (totalMatches > 0 ? `${totalMatches} result${totalMatches !== 1 ? 's' : ''} found` : '')}
        </SearchCount>
        <NeedHelp>
          Need help? <a href="mailto:ahsupport@truefocusnow.com">ahsupport@truefocusnow.com</a>
        </NeedHelp>
      </HeroSection>

      <ContentWrap>
        <Layout>
          <Sidebar>
            <SidebarTitle>Jump to Section</SidebarTitle>
            <SidebarNav>
              {faqData.map((section) => (
                <SidebarLink key={section.id} onClick={() => scrollToSection(section.id)}>
                  <Dot />
                  {section.title}
                </SidebarLink>
              ))}
            </SidebarNav>
          </Sidebar>

          <Main>
            {visibleData.length === 0 && (
              <NoResults>
                <div style={{ fontSize: '2.4rem', marginBottom: 12 }}>🔍</div>
                <h3>No results found</h3>
                <p>Try different keywords or browse the sections directly.</p>
              </NoResults>
            )}

            {visibleData.map((section) => {
              const collapsed = collapsedSections.has(section.id) && !q
              return (
                <Section key={section.id} id={section.id}>
                  <SecHeader onClick={() => toggleSection(section.id)}>
                    <SecIcon>{section.icon}</SecIcon>
                    <SecTitle>{section.title}</SecTitle>
                    <SecCount>{section.items.length} Q</SecCount>
                    <SecChev $collapsed={collapsed}>▼</SecChev>
                  </SecHeader>
                  <SecBody $collapsed={collapsed}>
                    {section.items.map((item) => {
                      const isOpen = openItems.has(item.id) || Boolean(q)
                      return (
                        <FaqItemWrap key={item.id}>
                          <FaqQ onClick={() => toggleItem(item.id)}>
                            <Qid>{item.id}</Qid>
                            <QText>{item.q}</QText>
                            <QChev $open={isOpen}>▼</QChev>
                          </FaqQ>
                          <FaqA $open={isOpen} dangerouslySetInnerHTML={{ __html: item.a }} />
                        </FaqItemWrap>
                      )
                    })}
                  </SecBody>
                </Section>
              )
            })}
          </Main>
        </Layout>
      </ContentWrap>

      <Footer>
        <strong>Appraisal Hunter™</strong> — Powered by TrueFocus Automation &nbsp;|&nbsp;
        <a href="mailto:ahsupport@truefocusnow.com">ahsupport@truefocusnow.com</a> &nbsp;|&nbsp; ©
        2026 TrueFocus Automation. All rights reserved.
      </Footer>
    </div>
  )
}

export default FaqPage